import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { CommonFieldSet, HysteresisFieldSet } from 'src/Libs/wallboxes/components/settings/tiles'
import WallboxSettingsFormGridContainer from './WallboxSettingsFormGridContainer'
import WallboxSettingsFormGridItem from './WallboxSettingsFormGridItem'

interface Props {
  model: WallboxConfigurationModel
  hasWritingAccess: boolean
}

/**
 * Generic configured form component for a Wallbox configuration without any variant
 * specialization (@see https://docs.e3dc.com/x/zgrIAw)
 */
const WallboxSettingsDefaultForm: React.FC<Props> = ({ model, hasWritingAccess }) => {
  return (
    <SettingsFormContainer model={model}>
      <WallboxSettingsFormGridContainer>
        <WallboxSettingsFormGridItem>
          <CommonFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>

        <WallboxSettingsFormGridItem>
          <HysteresisFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>
      </WallboxSettingsFormGridContainer>
    </SettingsFormContainer>
  )
}

export default WallboxSettingsDefaultForm
